class VideoOverlayPlay extends HTMLElement {
  connectedCallback() {
    this.block = this.closest(".group__block--image-with-text");
    this.content = this.block?.querySelector(".group__block--content");
    this.banner = this.closest(".overlay-bg");
    this.playBtn = this.querySelector(".play-video");
    this.muteBtn = this.querySelector(".mute-button");
    this.muteControl = this.querySelector(".video-overlay-control");
    this.loaded = false;

    if (this.playBtn) {
      this.playBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.loadAndPlay();
      });
    }

    this.addEventListener("click", (e) => {
      if (!this.loaded) return;
      if (e.target.closest(".mute-button")) return;
      if (e.target.closest(".play-video")) return;
      this.toggle();
    });

    if (this.muteBtn) {
      this.muteBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.toggleMute();
      });
    }
  }

  loadAndPlay() {
    if (this.loaded) {
      this.toggle();
      return;
    }

    const template = this.querySelector("template");
    if (!template) return;

    const videoEl = template.content.querySelector("video");
    if (!videoEl) return;

    const video = videoEl.cloneNode(true);
    video.removeAttribute("muted");
    video.muted = false;

    const thumb = this.querySelector(".video-thumbnail");
    if (thumb) thumb.style.opacity = "0";

    // Move play button out of thumbnail so it stays clickable over the video
    const playBtnWrap = this.querySelector(".deferred-media__poster-button");
    if (playBtnWrap) this.appendChild(playBtnWrap);

    this.appendChild(video);
    this.video = video;
    this.loaded = true;

    video
      .play()
      .then(() => {
        this.setPlaying(true);
      })
      .catch(() => {
        video.muted = true;
        video.play();
        this.setPlaying(true);
        this.updateMuteIcon();
      });
  }

  toggle() {
    if (!this.video) return;
    if (this.video.paused) {
      this.video.play();
      this.setPlaying(true);
    } else {
      this.video.pause();
      this.setPlaying(false);
    }
  }

  setPlaying(playing) {
    // Fade overlay text
    if (this.content) {
      this.content.style.opacity = playing ? "0" : "";
      this.content.style.pointerEvents = playing ? "none" : "";
    }
    // Remove dark overlay on banner
    if (this.banner) {
      this.banner.style.setProperty("--overlay-opacity", playing ? "0%" : "");
    }
    // Show/hide mute control
    if (this.muteControl) {
      this.muteControl.style.display = playing ? "" : "none";
    }
    this.classList.toggle("is-playing", playing);
  }

  toggleMute() {
    if (!this.video) return;
    this.video.muted = !this.video.muted;
    this.updateMuteIcon();
  }

  updateMuteIcon() {
    if (!this.muteBtn) return;
    const unmutedIcon = this.muteBtn.querySelector(".icon-unmuted");
    const mutedIcon = this.muteBtn.querySelector(".icon-muted");
    if (this.video.muted) {
      if (unmutedIcon) unmutedIcon.style.display = "none";
      if (mutedIcon) mutedIcon.style.display = "";
    } else {
      if (unmutedIcon) unmutedIcon.style.display = "";
      if (mutedIcon) mutedIcon.style.display = "none";
    }
  }
}
customElements.define("video-overlay-play", VideoOverlayPlay);
